import { createContext } from 'react';
export const IntlContext = createContext();
